import { jsx as r } from "react/jsx-runtime";
import "react";
var a = (l) => /* @__PURE__ */ r("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...l,
  children: /* @__PURE__ */ r("path", {
    fill: "currentColor",
    d: "M17.628 17.21c3.62 0 6.593-2.98 6.593-6.605C24.22 6.978 21.246 4 17.628 4c-3.62 0-6.592 2.98-6.592 6.605a6.582 6.582 0 0 0 6.592 6.605Zm5.518.466-.359-.072-.25.251a7.047 7.047 0 0 1-4.945 2.011 7.047 7.047 0 0 1-4.945-2.01l-.214-.252-.359.072c-3.153.681-5.482 3.554-5.482 6.821v2.405a4.729 4.729 0 0 0 4.73 4.739h12.54a4.729 4.729 0 0 0 4.73-4.739v-2.405c.036-3.266-2.257-6.138-5.446-6.821Z"
  })
});
export {
  a as default
};
